<template>
  <div class="tw:w-full tw:mx-auto">
    <LaunchpadLoader v-if="isFullLoading" class="tw:w-full tw:flex tw:justify-center tw:items-center tw:flex-1" />
    <router-view v-else />
  </div>
</template>

<script setup>
/**
 * Studio Plus Layout Component — subscribe/payment flow
 * Auth redirect handled by useStudioPlusAuth composable centrally.
 * This view only controls loading state display.
 */
import { useStudioPlusAuth } from '@/composables/useStudioPlusAuth'
import LaunchpadLoader from '@/components/dashboard/common/LaunchpadLoader.vue'

const { isFullLoading } = useStudioPlusAuth()
</script>
